module.exports = __webpack_public_path__ + "media/images/details__prizeBox__season__second-7d97cbbf3d619f82ee8cd21fdff749ba.png";